"use client"

import { useEffect, useState } from "react"

export function ShaderAvatarBackground() {
  const [gradientStyle, setGradientStyle] = useState({
    backgroundImage: "linear-gradient(45deg, #9333EA, #FF6600, #8833FF, #E12AFB)",
  })

  // Create a simple animation effect to simulate the shader
  useEffect(() => {
    let animationFrame: number
    let angle = 45

    const animate = () => {
      angle = (angle + 0.1) % 360
      setGradientStyle({
        backgroundImage: `linear-gradient(${angle}deg, #9333EA, #FF6600, #8833FF, #E12AFB)`,
      })
      animationFrame = requestAnimationFrame(animate)
    }

    animationFrame = requestAnimationFrame(animate)

    return () => {
      cancelAnimationFrame(animationFrame)
    }
  }, [])

  return (
    <div
      style={{
        ...gradientStyle,
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        backgroundSize: "400% 400%",
        transition: "background-position 0.5s ease",
      }}
    />
  )
}
